import React from 'react';
export const ListContext = /*#__PURE__*/React.createContext({});
export const ListConsumer = ListContext.Consumer;